import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import ProfileThumbnail from "./ProfileThumbnail";
import { StickerButton } from "./Sticker";
import { formatApiError } from "../lib/api";
import { deleteProfileThumbnails } from "../lib/thumbnails";

export default function ThumbnailUploadField({
  dancerId,
  account,
  organizer,
  guestThumbnailUrl,
  organizerThumbnailUrl,
  role,
  name,
  onDancerUpdated,
  onOrganizerUpdated,
}) {
  account = account ?? organizer;
  const [removing, setRemoving] = useState(false);

  const previewUrl = guestThumbnailUrl || organizerThumbnailUrl || account?.provider_photo_url || null;
  const hasThumbnail = Boolean(previewUrl);

  async function handleRemove() {
    if (!hasThumbnail) return;
    setRemoving(true);
    try {
      const { dancer, organizer: org } = await deleteProfileThumbnails({
        dancerId,
        organizerSignedIn: Boolean(account),
      });
      if (dancer) onDancerUpdated?.(dancer);
      if (org) onOrganizerUpdated?.(org);
      toast.success("Thumbnail removed");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setRemoving(false);
    }
  }

  return (
    <div className="flex items-start gap-4" data-testid="thumbnail-upload-field">
      <ProfileThumbnail
        name={name}
        role={role}
        thumbnailUrl={previewUrl}
        size="lg"
      />
      <div className="min-w-0 flex-1 space-y-2">
        <p className="font-display font-bold text-[13px] uppercase tracking-wider">Thumbnail</p>
        <p className="text-[12px] font-semibold text-ink/65 leading-snug">
          {hasThumbnail
            ? "Your photo from sign-in. You can remove it anytime."
            : "Your photo appears here after you sign in with Google or Apple."}
        </p>
        <div className="flex flex-wrap gap-2">
          {hasThumbnail && (
            <StickerButton
              type="button"
              color="ink"
              className="text-[13px]"
              disabled={removing}
              onClick={handleRemove}
              data-testid="thumbnail-remove-btn"
            >
              <Trash2 className="w-4 h-4" strokeWidth={3} />
              Remove
            </StickerButton>
          )}
        </div>
      </div>
    </div>
  );
}
